import type * as React from "react";

export enum InputMethod {
  NotDefined = -1 /* Used only for converting TryToSetIpSelection to use default parameters instead of [AlternateSignature] */,
  Unknown = 0,
  Keyboard = 1,
  Mouse = 2,
  Touch = 3,
  Pen = 4,
  CrossSlide = 9,
}

export function getInputMethodFromEvent(
  ev?: React.MouseEvent<any> | React.KeyboardEvent<any> | React.FocusEvent<any>
): InputMethod | undefined {
  let inputMethod = undefined;
  if (ev) {
    const type = ev.type.toLowerCase();
    if (type === "click") {
      inputMethod =
        ev.nativeEvent.detail === 0 ? InputMethod.Keyboard : InputMethod.Mouse;
    } else if (type === "keydown" || type === "keypress" || type === "keyup") {
      inputMethod = InputMethod.Keyboard;
    } else if (type === "mousedown" || type === "mouseup") {
      inputMethod = InputMethod.Mouse;
    }
  }
  return inputMethod;
}
